export default __webpack_public_path__ + "static/media/logo-fridaaXpartner-ok.5bf9e023.png";